export function toApiIso(value: Date, isAllDay: boolean): string {
  if (!isAllDay) return value.toISOString();
  return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())).toISOString();
}

export function nextAllDayEnd(day: Date): Date {
  const end = new Date(day);
  end.setDate(end.getDate() + 1);
  end.setHours(0, 0, 0, 0);
  return end;
}

export function defaultPartialDayRange(baseDate?: Date): { start: Date; end: Date } {
  const start = baseDate ? new Date(baseDate) : new Date();
  start.setHours(9, 0, 0, 0);
  const end = new Date(start);
  end.setHours(17, 0, 0, 0);
  return { start, end };
}

export function localMidnight(day: Date): Date {
  const d = new Date(day);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** True when the entry start is before now (past calendar days for all-day, exact time for timed). */
export function isTimeOffStartInPast(startLocal: Date, isAllDay: boolean, now: Date = new Date()): boolean {
  if (isAllDay) {
    return localMidnight(startLocal).getTime() < localMidnight(now).getTime();
  }
  return startLocal.getTime() < now.getTime();
}
